import Page from "./Page";
import HeaderVideo from "./HeaderVideo";

export default class Recipe extends Page {
	constructor() {
		console.log('Recipe');
		super();
		new HeaderVideo();
	}


}